const INVALID_CHARACTERS = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
const TEXT_FIELDS = ['number_shipping', 'rel_trans_documentid', 'rel_trans_tradename', 'rel_trans_street', 'vehiclestore_licenseplate', 'vehiclestore_documentid', 'vehiclestore_trailer', 'vehiclestore_defaultdriver', 'opt_tras_documentid', 'opt_tras_tradename', 'opt_tras_street', 'dest_tras_documentid', 'dest_tras_tradename', 'dest_tras_street', 'service_1', 'service_2', 'service_3', 'observations', 'origin_street', 'destine_street'];
export const validateShipping = (shipping = {}) => {
  const errors = {};
  TEXT_FIELDS.forEach(field => {
    if (INVALID_CHARACTERS.test(shipping[field] ?? '')) {
      errors[field] = 'Text_TextNoValid';
    }
  });
  return {
    ...errors,
    ...validateShippingRequired(shipping)
  };
};
export const validateShippingRequired = (shipping = {}) => {
  const errors = {};
  if (shipping.date_shipping == null || shipping.date_shipping === '' || Number.isNaN(new Date(shipping.date_shipping).getTime())) {
    errors.date_shipping = 'Text_FieldDateShippingRequired';
  }
  if (!shipping.vehiclestore_licenseplate?.trim()) {
    errors.vehiclestore_licenseplate = 'Text_FieldLicensePlateShippingRequired';
  }
  return errors;
};